<template>
  <div class="komship-expedition-schema px-[16px]">
    <!-- Navigation Tabs -->
    <div class="mb-3">
      <div class="tab-container">
        <button
          type="button"
          class="tab-btn"
          :class="{ active: tabIndex === 0 }"
          @click="tabIndex = 0"
        >
          Biaya Ekspedisi
        </button>
        <button
          type="button"
          class="tab-btn"
          :class="{ active: tabIndex === 1 }"
          @click="tabIndex = 1"
        >
          Service Ekspedisi
        </button>
      </div>
    </div>

    <!-- Tab Content -->
    <div>
      <div v-if="tabIndex === 0">
        <TableExpeditionsFee />
      </div>
      <div v-else>
        <TableExpeditionsService />
      </div>
    </div>
  </div>
</template>

<script>
import TableExpeditionsFee from './component/TableExpeditionsFee.vue'
import TableExpeditionsService from './component/TableExpeditionsService.vue'

export default {
  name: 'KomshipExpeditionSchema',
  components: { TableExpeditionsFee, TableExpeditionsService },
  data() {
    return {
      tabIndex: 0,
    }
  },
}
</script>

<style scoped>
/* Tabs */
.tab-container {
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 3px;
  gap: 3px;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:focus {
    outline: none;
  }

  &.active {
    background-color: #ffffff;
    color: #111827;
    font-weight: 600;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  &:hover:not(.active) {
    color: #111827;
  }
}
</style>
